import { Pipe, PipeTransform } from "@angular/core";
import { formatDate } from "../utils/date";

@Pipe({
  name: "dateFormat",
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string | Date, type?: string): string {
    return formatDate(value, type);
  }
}
